import { render, staticRenderFns } from "./ViewAllVehicleCompany.vue?vue&type=template&id=706f7b1c"
import script from "./ViewAllVehicleCompany.vue?vue&type=script&lang=js"
export * from "./ViewAllVehicleCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports